import axios from "../plugins/axios";
import { PORTAL_CONFIG } from "../config";

export default {
  // eslint-disable-next-line no-unused-vars
  getUserProfile: function() {
    return axios.get(`/getMyProfiles/?app_token=${PORTAL_CONFIG.APP_TOKEN}`);
  },
  getFullSession() {
    return axios.get(`/getFullSession/?app_token=${PORTAL_CONFIG.APP_TOKEN}`);
  },
  getUserData(id) {
    return axios.get(`/USER/${id}/?app_token=${PORTAL_CONFIG.APP_TOKEN}`);
  },
  getEntity: function() {
    return axios.get(
      `/Entity/?app_token=${PORTAL_CONFIG.APP_TOKEN}&range=0-1000`
    );
  },
  getUserEntity: function() {
    return axios.get(`/getMyEntities/?app_token=${PORTAL_CONFIG.APP_TOKEN}`);
  },
  setActiveEntity(entity_id) {
    return axios.post(
      `changeActiveEntities/?app_token=${PORTAL_CONFIG.APP_TOKEN}&entities_id=${entity_id}`
    );
  },
  occupants() {
    return axios.get(
      `/PluginGenericobjectOccupant/?app_token=${PORTAL_CONFIG.APP_TOKEN}&range=0-1000`
    );
  },
  getOccupants() {
    return axios.get(
      `/PluginFieldsEntitypiloteimmooccupant/?app_token=${PORTAL_CONFIG.APP_TOKEN}&range=0-1000`
    );
  },
  getCharge() {
    return axios.get(
      `/PluginGenericobjectCharge/?app_token=${PORTAL_CONFIG.APP_TOKEN}&range=0-1000`
    );
  },
  getTravaux() {
    return axios.get(
      `/PluginGenericobjectTravauxger/?app_token=${PORTAL_CONFIG.APP_TOKEN}&range=0-1000`
    );
  },
  getDocuments(entity_id) {
    return axios.get(
      `/Entity/${entity_id}/Document_Item/?app_token=${PORTAL_CONFIG.APP_TOKEN}&range=0-1000`
    );
  },
  getDocument(document_id, blob = false) {
    if (blob) {
      return axios(
        `/Document/${document_id}/?app_token=${PORTAL_CONFIG.APP_TOKEN}&alt=media`,
        {
          responseType: "blob" // important,
        }
      );
    } else {
      return axios.get(
        `/Document/${document_id}?app_token=${PORTAL_CONFIG.APP_TOKEN}&range=0-1000`
      );
    }
  },
  downloadDocument(item) {
    axios(
      `/Document/${item.id}/?app_token=${PORTAL_CONFIG.APP_TOKEN}&alt=media`,
      {
        responseType: "blob" // important,
      }
    ).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", item.filename); //or any other extension
      document.body.appendChild(link);
      link.click();
    });
  },
  openDocument(item) {
    axios(
      `/Document/${item.id}/?app_token=${PORTAL_CONFIG.APP_TOKEN}&alt=media`,
      {
        responseType: "blob" // important,
      }
    ).then(response => {
      const url = URL.createObjectURL(response.data);
      window.open(
        url,
        item.filename,
        "menubar=no,status=no,scrollbars=no,width=800,height=800"
      );
    });
  },

  getEquipment(equipmentNom) {
    return axios.get(
      `/PluginGenericobject${equipmentNom}/?app_token=${PORTAL_CONFIG.APP_TOKEN}&range=0-1000`
    );
  },
  getEquipmentTicketItems(equipmentId, equipmentNom) {
    return axios.get(
      `/PluginGenericobject${equipmentNom}/${equipmentId}/Item_Ticket?app_token=${PORTAL_CONFIG.APP_TOKEN}&range=0-1000`
    );
  },
  getRoom() {
    return axios.get(
      `/PluginGenericobjectRoom/?app_token=${PORTAL_CONFIG.APP_TOKEN}`
    );
  },
  getRoomTicketItems(roomId) {
    return axios.get(
      `/PluginGenericobjectRoom/${roomId}/Item_Ticket?app_token=${PORTAL_CONFIG.APP_TOKEN}&range=0-1000`
    );
  },
  getAllTickets() {
    return axios.get(
      `/Ticket/?app_token=${PORTAL_CONFIG.APP_TOKEN}&range=0-1000&order=DESC&get_hateoas=false`
    );
  },
  getTickets() {
    return axios.get(
      `/Ticket/?app_token=${PORTAL_CONFIG.APP_TOKEN}&range=0-1000&order=DESC&expand_dropdowns=true&get_hateoas=false`
    );
  },
  getTicket(ticketID) {
    return axios.get(
      `/Ticket/${ticketID}?app_token=${PORTAL_CONFIG.APP_TOKEN}`
    );
  },
  getTicketsFields() {
    return axios.get(
      `/PluginFieldsTicketpiloteimmo/?app_token=${PORTAL_CONFIG.APP_TOKEN}&range=0-1000`
    );
  },
  getITILSolution(ticketID) {
    return axios.get(
      `/Ticket/${ticketID}/ITILSolution/?app_token=${PORTAL_CONFIG.APP_TOKEN}&range=0-1000`
    );
  },
  getITILFollowup(ticketID) {
    return axios.get(
      `/Ticket/${ticketID}/ITILFollowup/?app_token=${PORTAL_CONFIG.APP_TOKEN}&range=0-1000`
    );
  },
  getTicketTask(ticketID) {
    return axios.get(
      `/Ticket/${ticketID}/TicketTask/?app_token=${PORTAL_CONFIG.APP_TOKEN}&range=0-1000`
    );
  },
  getPhotos() {
    return axios.get(
      `/document/?app_token=${PORTAL_CONFIG.APP_TOKEN}&range=0-1000`
    );
  },
  changeActiveEntity() {
    return axios.post(
      `changeActiveEntities/?app_token=${PORTAL_CONFIG.APP_TOKEN}`
    );
  },
  loadDoc() {
    return axios.get(
      `document/?app_token=${PORTAL_CONFIG.APP_TOKEN}&range=0-1000&expand_dropdowns=true`
    );
  },
  getActiveEntity() {
    return axios.get(`/entity/?app_token=${PORTAL_CONFIG.APP_TOKEN}`);
  },
  updateComment(id, comment) {
    return axios.put(`/Entity/${id}/?app_token=${PORTAL_CONFIG.APP_TOKEN}`, {
      input: {
        comment
      }
    });
  },

  getAllITILSolutions() {
    return axios.get(
      `/ITILSolution/?app_token=${PORTAL_CONFIG.APP_TOKEN}&range=0-1000`
    );
  },
  getAllITILFollowups() {
    return axios.get(
      `/ITILFollowup/?app_token=${PORTAL_CONFIG.APP_TOKEN}&range=0-1000`
    );
  },
  getLocations() {
    return axios.get(
      `/location/?app_token=${PORTAL_CONFIG.APP_TOKEN}&range=0-1000`
    );
  },
  addNote(entityID, note) {
    return axios.post(`/notepad/?app_token=${PORTAL_CONFIG.APP_TOKEN}`, {
      input: {
        content: note,
        itemtype: "entity",
        items_id: entityID
      }
    });
  },
  getEntityNote(entityID) {
    return axios.get(
      `/entity/${entityID}/notepad/?app_token=${PORTAL_CONFIG.APP_TOKEN}&order=DESC&range=0-1000`
    );
  },
  getProjects() {
    return axios.get(
      `/project/?app_token=${PORTAL_CONFIG.APP_TOKEN}&range=0-1000`
    );
  },
  getProjectTask(projectID) {
    return axios.get(
      `/${projectID}/ProjectTask/?app_token=${PORTAL_CONFIG.APP_TOKEN}&range=0-1000`
    );
  },
  getAllProjectTask() {
    return axios.get(
      `/ProjectTask/?app_token=${PORTAL_CONFIG.APP_TOKEN}&range=0-1000`
    );
  },
  getDocumentCategories() {
    return axios.get(
      `/DocumentCategory/?app_token=${PORTAL_CONFIG.APP_TOKEN}&range=0-1000`
    );
  },
  getUsers(){
    return axios.get(`/USER/?app_token=${PORTAL_CONFIG.APP_TOKEN}`);
  }

};
